import React, { Fragment, useCallback, useEffect } from 'react';

import '../../../../css/components/batches/CardBody.css';

import Traductor from '../../../Traductor';

const CardBody = ({ info, loading, idStatus, amount }) => {
    const t = new Traductor();
    useEffect(() => {
        window.bronson.ComponentRegister.initAll();
    }, [idStatus, amount]);

    const renderStatus = useCallback(
        status => {
            const icons = {
                [t.getTraduction('ManagementFiltersStatus')[1]]: 'success',
                [t.getTraduction('ManagementFiltersStatus')[5]]: 'warning',
            };
            const colors = {
                [t.getTraduction('ManagementFiltersStatus')[4]]: 'brand',
                [t.getTraduction('ManagementFiltersStatus')[2]]: 'muted',
            };
            switch (status) {
                case t.getTraduction('ManagementFiltersStatus')[1]:
                case t.getTraduction('ManagementFiltersStatus')[5]:
                    return (
                        <span
                            className={`c-notification--${
                                icons[status]
                            }  u-ph-small u-pv-xsmall  ${
                                amount ? '' : 'u-disabled'
                            }`}
                        >
                            {status}
                        </span>
                    );
                case t.getTraduction('ManagementFiltersStatus')[4]:
                case t.getTraduction('ManagementFiltersStatus')[2]:
                    return (
                        <span className={`u-text-${colors[status]}`}>
                            <span className="c-dl-horizontal-important-label">
                                {t.getTraduction(status)}
                            </span>
                            {/* Date*/}
                        </span>
                    );
                default:
                    return status;
            }
        },
        [t]
    );

    const renderInfo = () => {
        if (loading) {
            return new Array(4).fill(0).map((e, i) => (
                <Fragment key={i}>
                    <dt className="c-dl-horizontal__title u-inline-item u-mb c-dl-skeleton" />
                    <dd className="c-dl-horizontal__item u-text-right u-inline-item  u-mb c-dl-skeleton" />
                </Fragment>
            ));
        }

        return info.map(([key, value], i) => (
            <Fragment key={`${key}${i}`}>
                <dt className="c-dl-horizontal__title u-inline-item u-mb">
                    {key}
                    {i === 0 &&
                        amount > 0 &&
                        value !==
                            t.getTraduction('ManagementFiltersStatus')[2] &&
                        value !==
                            t.getTraduction('ManagementFiltersStatus')[4] && (
                            <button
                                type="button"
                                className="c-icon c-info-icon js-tooltip c-icon--[semantic-info] c-icon--xxsmall"
                                data-tippy-content={
                                    t.getTraduction('BatchStatusTip')[idStatus]
                                }
                                data-tippy-placement="top"
                            />
                        )}
                </dt>
                <dd
                    className={`c-dl-horizontal__item u-text-right u-inline-item u-text-brand u-mb ${
                        i !== info.length - 1 ? 'u-font-initial' : ''
                    }`}
                >
                    {i === 0 ? renderStatus(value) : value}
                </dd>
            </Fragment>
        ));
    };
    return (
        <div className="c-card__body u-p-none">
            <dl className="c-dl-horizontal  u-flex">{renderInfo()}</dl>
        </div>
    );
};

export default CardBody;
